import { jsxs as n, jsx as e } from "react/jsx-runtime";
import { svgIconStyles as t } from "../svg-icon/SvgIcon.styles.js";
function s({
  label: C,
  className: l,
  size: o,
  ...i
}) {
  return /* @__PURE__ */ n(
    "svg",
    {
      viewBox: "0 0 24 24",
      fill: "none",
      "data-title": "messageOutline",
      stroke: "none",
      role: "img",
      "aria-hidden": !C,
      focusable: "false",
      className: t({ className: l, size: o }),
      ...i,
      children: [
        C && /* @__PURE__ */ e("title", { children: C }),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.113 4H8.88703C7.64868 4 6.84021 4.00156 6.22277 4.052C5.62869 4.10054 5.38966 4.18419 5.25822 4.25116C4.82462 4.47209 4.47209 4.82462 4.25116 5.25822C4.18419 5.38966 4.10054 5.62869 4.052 6.22277C4.00156 6.84021 4 7.64868 4 8.88703V12.113C4 13.3513 4.00156 14.1598 4.052 14.7772C4.10054 15.3713 4.18419 15.6103 4.25116 15.7418C4.47209 16.1754 4.82462 16.5279 5.25822 16.7488C5.38966 16.8158 5.62869 16.8995 6.22277 16.948C6.84021 16.9984 7.64868 17 8.88702 17H16.0562C16.096 17 16.1355 17 16.1749 16.9999C16.7169 16.9994 17.2281 16.9989 17.7358 17.0951C18.1813 17.1795 18.6146 17.3193 19.0256 17.5111C19.3689 17.6714 19.6834 17.875 20 18.0972V8.88703C20 7.64868 19.9984 6.84021 19.948 6.22277C19.8995 5.62869 19.8158 5.38966 19.7488 5.25822C19.5279 4.82462 19.1754 4.47209 18.7418 4.25116C18.6103 4.18419 18.3713 4.10054 17.7772 4.052C17.1598 4.00156 16.3513 4 15.113 4ZM19.9829 20.1608L19.9834 20.1578L19.9829 20.1608ZM2.46915 4.35024C2 5.271 2 6.47634 2 8.88703V12.113C2 14.5237 2 15.729 2.46915 16.6498C2.88183 17.4597 3.54032 18.1182 4.35024 18.5308C5.271 19 6.47634 19 8.88702 19H16.0562C16.716 19 17.0459 19 17.3635 19.0602C17.6454 19.1136 17.9195 19.202 18.1794 19.3233C18.4724 19.4601 18.7401 19.6529 19.2755 20.0384L19.8178 20.4288C20.5225 20.9362 20.8748 21.1899 21.1687 21.1797C21.4247 21.1709 21.6634 21.0487 21.82 20.8461C22 20.6135 22 20.1793 22 19.311V8.88703C22 6.47634 22 5.271 21.5308 4.35024C21.1182 3.54032 20.4597 2.88183 19.6498 2.46915C18.729 2 17.5237 2 15.113 2H8.88703C6.47634 2 5.271 2 4.35024 2.46915C3.54032 2.88183 2.88183 3.54032 2.46915 4.35024Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7 7.99994C7 7.44765 7.44772 6.99994 8 6.99994H16C16.5523 6.99994 17 7.44765 17 7.99994 17 8.55222 16.5523 8.99994 16 8.99994H8C7.44772 8.99994 7 8.55222 7 7.99994ZM7 11.9999C7 11.4477 7.44772 10.9999 8 10.9999H12C12.5523 10.9999 13 11.4477 13 11.9999 13 12.5522 12.5523 12.9999 12 12.9999H8C7.44772 12.9999 7 12.5522 7 11.9999Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}
export {
  s as MessageOutlineIcon,
  s as default
};
